// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAlu_3mtUtofrX1TsxemgUs1r6-gEf_j_Q",
  authDomain: "resmenu-c1b90.firebaseapp.com",
  projectId: "resmenu-c1b90",
  storageBucket: "resmenu-c1b90.appspot.com",
  messagingSenderId: "142367069819",
  appId: "1:142367069819:web:f1c79ebd5b924b98f2f4de",
  measurementId: "G-C55G2NCHYR",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);

export const db = getFirestore(app);
export const storage = getStorage(app);
